export enum EInvoiceDelivery {
  doNotPost = 'doNotPost',
  byPost = 'byPost',
}
